import { CombineClientsModal } from '@app/components/Modals';

import { PF } from '@pages/DublicateClients/data/constants';
import {
  useDublicateClients,
  useDublicateClientsEffects,
} from '@pages/DublicateClients/hooks';
import { Filters, Table } from '@pages/DublicateClients/ui';

import '@pages/DublicateClients/styles/DublicateClientsPage.desktop.scss';

export const DublicateClientsPage = () => {
  const {
    onChangeSearchTerm,
    onChangeStatuses,
    unsavedFilters,
    skipFilters,
    onSearch,
    getFiltersHandler,
    statusesOptions,
    getDublicateClientsHandler,
    disabled,
    data,
    onPaginate,
    onPageSizeChange,
    isFetching,
    isPageLoading,
    closeCombineClientsModal,
    columns,
    isOpenCombineClientsModal,
    combineClients,
    onSaveCombineClients,
    onMarkNotDuplicate,
  } = useDublicateClients();

  useDublicateClientsEffects({
    getFiltersHandler,
    getDublicateClientsHandler,
  });

  return (
    <div className={`${PF}_container`}>
      <Filters
        unsavedFilters={unsavedFilters}
        onChangeSearchTerm={onChangeSearchTerm}
        onChangeStatuses={onChangeStatuses}
        skipFilters={skipFilters}
        onSearch={onSearch}
        disabled={disabled}
        statusesOptions={statusesOptions}
      />
      <Table
        data={data}
        onPaginate={onPaginate}
        onPageSizeChange={onPageSizeChange}
        isFetching={isFetching}
        isPageLoading={isPageLoading}
        pagination={unsavedFilters}
        columns={columns}
      />

      <CombineClientsModal
        open={isOpenCombineClientsModal}
        combineClients={combineClients}
        onCancel={closeCombineClientsModal}
        onSave={onSaveCombineClients}
        onMarkNotDuplicate={onMarkNotDuplicate}
      />
    </div>
  );
};
